webpackJsonp([38],{

/***/ 1508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Policy_vue__ = __webpack_require__(1806);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70a34df3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Policy_vue__ = __webpack_require__(1927);
function injectStyle (ssrContext) {
  __webpack_require__(1925)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70a34df3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Policy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70a34df3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Policy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo.a7b8e63.svg";

/***/ }),

/***/ 1660:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/TransparencyLogo.9957347.svg";

/***/ }),

/***/ 1806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 1925:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1926);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("0ed8f028", content, true, {});

/***/ }),

/***/ 1926:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".top-logo-bar[data-v-70a34df3]{width:100%;height:100px;background:#347c93}.section-header[data-v-70a34df3]{margin-bottom:20px;margin-top:40px;font-weight:600;font-size:24px}.main-header[data-v-70a34df3]{font-weight:700;font-size:32px;margin-top:20px}section[data-v-70a34df3]{padding-right:40vw}p[data-v-70a34df3]{text-align:justify}li[data-v-70a34df3]{font-weight:700}.policy-container[data-v-70a34df3]{height:calc(100% - 100px);overflow-y:scroll;padding-left:calc(15vw + 30px)}@media only screen and (max-width:700px){.policy-container[data-v-70a34df3]{padding-left:5%}section[data-v-70a34df3]{padding-right:5%}}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Policy.vue"],"names":[],"mappings":"AACA,+BACI,WAAY,AACZ,aAAc,AACd,kBAAoB,CACvB,AACD,iCACI,mBAAoB,AACpB,gBAAiB,AACjB,gBAAiB,AACjB,cAAgB,CACnB,AACD,8BACI,gBAAiB,AACjB,eAAgB,AAChB,eAAiB,CACpB,AACD,yBACI,kBAAoB,CACvB,AACD,mBACI,kBAAoB,CAEvB,AACD,oBACI,eAAiB,CACpB,AACD,mCACI,0BAA2B,AAC3B,kBAAmB,AACnB,8BAAgC,CACnC,AACD,yCACA,mCACQ,eAAiB,CACxB,AACD,yBACQ,gBAAkB,CACzB,CACA","file":"Policy.vue","sourcesContent":["\n.top-logo-bar[data-v-70a34df3] {\n    width: 100%;\n    height: 100px;\n    background: #347C93;\n}\n.section-header[data-v-70a34df3] {\n    margin-bottom: 20px;\n    margin-top: 40px;\n    font-weight: 600;\n    font-size: 24px;\n}\n.main-header[data-v-70a34df3] {\n    font-weight: 700;\n    font-size: 32px;\n    margin-top: 20px;\n}\nsection[data-v-70a34df3] {\n    padding-right: 40vw;\n}\np[data-v-70a34df3] {\n    text-align: justify;\n    /* margin-left: 2vw; */\n}\nli[data-v-70a34df3] {\n    font-weight: 700;\n}\n.policy-container[data-v-70a34df3] {\n    height: calc(100% - 100px); \n    overflow-y: scroll; \n    padding-left: calc(15vw + 30px);\n}\n@media only screen and (max-width: 700px) {\n.policy-container[data-v-70a34df3] {\n        padding-left: 5%;\n}\nsection[data-v-70a34df3] {\n        padding-right: 5%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"top-logo-bar",staticStyle:{"display":"flex","align-items":"center"}},[_c('router-link',{staticStyle:{"align-items":"left","display":"flex"},attrs:{"to":{name: 'login'}}},[_c('img',{staticClass:"app-logo",staticStyle:{"margin-left":"10vw","height":"35px","margin-top":"0px","padding-right":"20px","border-right":"1px solid #AEAEAE7F"},attrs:{"src":__webpack_require__(1620)}}),_vm._v(" "),_c('img',{staticClass:"app-logo",staticStyle:{"margin-left":"20px","height":"35px","margin-top":"0px"},attrs:{"src":__webpack_require__(1660)}})])],1)]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"policy-container"},[_c('div',{staticClass:"main-header"},[_vm._v("GDPR Privacy Policy of BioControl")]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"30px"}},[_c('div',[_c('p',{staticStyle:{"margin":"unset","font-weight":"600"}},[_vm._v("Last updated: Apr 26, 2021")])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("Definitions")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("BioControl")]),_c('br'),_vm._v("BioControl means BioControl AS, BioControl Polska, BioControl North America with its principal place of business at 75 Gautestadveien, 1890 Rakkestad, Norway.")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("GDPR")]),_c('br'),_vm._v("General Data Protection Regulation Act.")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Data Controller")]),_c('br'),_vm._v("Data Controller means the natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal information are, or are to be, processed.")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Data Processor")]),_c('br'),_vm._v("Data Processor means any natural or legal person who processes the data on behalf of the Data Controller.")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Data Subject")]),_c('br'),_vm._v("Data Subject is any living individual who is using our Service and is the subject of Personal Data.")])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("1. Principles for processing personal data")]),_vm._v(" "),_c('p',[_vm._v("Our principles for processing personal data are:")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Fairness and lawfulness.")]),_vm._v(" When we process personal data, the individual rights of the Data Subjects must be protected. All personal data must be collected and processed in a legal and fair manner.")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Restricted to a specific purpose.")]),_vm._v(" The personal data of Data Subject must be processed only for specific purposes.")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Transparency.")]),_vm._v(" The Data Subject must be informed of how his/her data is being collected, processed and used.")])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("2. What personal and system data we collect and process")]),_vm._v(" "),_c('p',[_vm._v("BioControl collects several different types of personal data for various purposes. Personal Data may include, but is not limited to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Email address")]),_vm._v(" "),_c('li',[_vm._v("Account password")]),_vm._v(" "),_c('li',[_vm._v("First name and last name")]),_vm._v(" "),_c('li',[_vm._v("Phone number")]),_vm._v(" "),_c('li',[_vm._v("Address, State, Province, ZIP/Postal code, City")])]),_vm._v(" "),_c('p',[_vm._v("What is more, BioControl collects several different types of system data for various purposes (e.g. system diagnostics). System Data may include, but is not limited to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("System location")]),_vm._v(" "),_c('li',[_vm._v("IP Address")]),_vm._v(" "),_c('li',[_vm._v("Software, firmware version")]),_vm._v(" "),_c('li',[_vm._v("Alarms in the system")]),_vm._v(" "),_c('li',[_vm._v("Current system status")])]),_vm._v(" "),_c('p',[_vm._v("Please note, BioControl will never collect and store your logs/visits data (consumption logs, visit logs) unless prior consent from system owner. What is more, BioControl will not forward/sell any information to other parties. ")])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("3. How we use the personal and system data")]),_vm._v(" "),_c('p',[_vm._v("BioControl uses the collected personal and system data for various purposes:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("To provide you with services")]),_vm._v(" "),_c('li',[_vm._v("To notify you about changes to our services and/or products")]),_vm._v(" "),_c('li',[_vm._v("To provide customer support")]),_vm._v(" "),_c('li',[_vm._v("To gather analysis or valuable information so that we can improve our services")]),_vm._v(" "),_c('li',[_vm._v("To detect, prevent and address technical issues")])])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("4. Legal basis for collecting and processing personal data")]),_vm._v(" "),_c('p',[_vm._v("BioControl legal basis for collecting and using the personal data described in this Data Protection Policy depends on the personal data we collect and the specific context in which we collect the information:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("BioControl needs to perform a contract with you")]),_vm._v(" "),_c('li',[_vm._v("You have given BioControl permission to do so")]),_vm._v(" "),_c('li',[_vm._v("Processing your personal data is in BioControl legitimate interests")]),_vm._v(" "),_c('li',[_vm._v("BioControl needs to comply with the law")])])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("5. Retention of personal data")]),_vm._v(" "),_c('p',[_vm._v("BioControl will retain your personal information only for as long as is necessary for the purposes set out in this Data Protection Policy.")]),_vm._v(" "),_c('p',[_vm._v("BioControl will retain and use your information to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our policies.")])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("6. Data transfers")]),_vm._v(" "),_c('p',[_vm._v("BioControl may transfer to, and store the data we collect about you and system in, countries other than the country in which the data was originally collected, including the United States, Canada or other destinations outside the European Economic Area (“EEA”). Those countries may not have the same data protection laws as the country in which you provided the data. When we transfer your data to other countries, we will protect the data as described in this Privacy Policy and comply with applicable legal requirements providing adequate protection for the transfer of data to countries outside the EEA.")]),_vm._v(" "),_c('p',[_vm._v("If you are located in the EEA, we will only transfer your personal and system data if:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The country to which the personal data will be transferred has been granted a European Commission adequacy decision;")]),_vm._v(" "),_c('li',[_vm._v("The recipient of the personal data is located in the US and has certified to the US-EU Privacy Shield Framework; or")]),_vm._v(" "),_c('li',[_vm._v("BioControl have put in place appropriate safeguards in respect of the transfer")])])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("7. Data protection rights")]),_vm._v(" "),_c('p',[_vm._v("If you are a resident of the European Economic Area (EEA), you have certain data protection rights. If you wish to be informed what personal data BioControl holds about you and if you want it to be removed from our systems, please contact us.")]),_vm._v(" "),_c('p',[_vm._v("In certain circumstances, you have the following data protection rights:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The right to access, update or to delete the information we have on you")]),_vm._v(" "),_c('li',[_vm._v("The right of rectification")]),_vm._v(" "),_c('li',[_vm._v("The right to object")]),_vm._v(" "),_c('li',[_vm._v("The right of restriction")]),_vm._v(" "),_c('li',[_vm._v("The right to data portability")]),_vm._v(" "),_c('li',[_vm._v("The right to withdraw consent")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/38.9f1e4929d638fc5e1d44.js